import Logo from "@/components/Logo";

/**
 * Premium animated loading screen.
 *
 * Subtle compass-spinning + radial pulse — designed for the global app boot
 * and for AuthBoot.
 */
export default function LoadingScreen({ label = "Loading" }) {
  return (
    <div
      className="min-h-screen grid place-items-center bg-background"
      role="status"
      aria-live="polite"
      data-testid="loading-screen"
    >
      <div className="flex flex-col items-center gap-6">
        <div className="relative">
          <div className="absolute inset-0 rounded-full bg-primary/10 blur-2xl animate-pulse" aria-hidden />
          <div className="orixa-loading-rotate">
            <Logo variant="symbol" size={72} as="div" />
          </div>
        </div>
        <div className="text-overline text-muted-foreground orixa-loading-fade">
          {label}
        </div>
      </div>
    </div>
  );
}
